import { Injectable } from '@angular/core';
import { RoleGuard } from './role.abstract.guard';

@Injectable({ providedIn: 'root' })
export class RrhhGuard extends RoleGuard {
  role: string[] = ['rrhh'];
}
